<div
  id="payee-cases-container"
  class="flex column"
>
  <payee-case-quick-filters [showTodoSubTabs]="showTodoSubTabs"></payee-case-quick-filters>
  <div id="case-table-filters">
    <payee-case-reference-id-filter></payee-case-reference-id-filter>
    <payee-case-debtor-name-filter></payee-case-debtor-name-filter>
    <payee-case-product-filter></payee-case-product-filter>
    <payee-case-stage-filter [stages]="stages"></payee-case-stage-filter>
    <payee-case-state-filter></payee-case-state-filter>
    <payee-case-started-at-filter></payee-case-started-at-filter>
    <payee-case-transition-filter></payee-case-transition-filter>
    <payee-case-client-filter
      [searchClients]="searchClients!"
      [resolveClient]="resolveClient!"
    ></payee-case-client-filter>
    @for (component of additionalFilters; track $index) {
      <ng-container [ngComponentOutlet]="component"></ng-container>
    }
    <payee-clear-filters></payee-clear-filters>
    @if (showExport) {
      <button
        type="button"
        class="export-cases-btn"
        [disabled]="exporting()"
        (click)="exportCases()"
      >
        <mat-icon>download</mat-icon>
        <span>{{ "CASES_TABLE.EXPORT.BUTTON" | translate }}</span>
      </button>
    }
  </div>
  @if (showInfo) {
    @if (draftSelected) {
      <payee-info class="state-info">
        {{ "CASES_TABLE.TABLE_INFO.DRAFT_INFO" | translate }}
      </payee-info>
    }
    @if (ongoingSelected) {
      <payee-info class="state-info">
        {{ "CASES_TABLE.TABLE_INFO.ONGOING_INFO" | translate }}
      </payee-info>
    }
    @if (closedSelected) {
      <payee-info class="state-info">
        {{ "CASES_TABLE.TABLE_INFO.CLOSED_INFO" | translate }}
      </payee-info>
    }
  }

  @if (!loading() && dataSource.data.length > 0) {
    <payee-cases-table
      [dataSource]="dataSource"
      [pagination]="pagination"
      [additionalColumns]="additionalColumns()"
      [additionalActions]="additionalActions"
      [allowDelete]="allowDelete"
      [allowEdit]="allowEdit"
      [showClientColumn]="showClientColumn()"
      [showPartnerColumn]="showPartnerColumn()"
      (page)="pageChange($event)"
    ></payee-cases-table>
  }

  @if (!loading() && dataSource.data.length === 0) {
    <h1
      id="no-case-found-text"
      data-testid="no-cases"
    >
      {{ "CASES_TABLE.NO_CASES.TITLE" | translate }}
    </h1>
  }

  @if (loading()) {
    <div class="cases-skeleton-table">
      <table
        mat-table
        class="skeleton-table mat-elevation-z1"
        [dataSource]="skeletonDataSource"
      >
        @for (colIndex of getSkeletonColumnArray(); track colIndex; let i = $index) {
          <ng-container [matColumnDef]="'skeleton-col-' + i">
            <th
              *matHeaderCellDef
              mat-header-cell
              class="skeleton-header-cell"
            ></th>
            <td
              *matCellDef="let element"
              mat-cell
              class="skeleton-cell"
            >
              <div
                class="skeleton-content"
                [class]="'skeleton-col-' + i"
              ></div>
            </td>
          </ng-container>
        }
        <tr
          *matHeaderRowDef="getSkeletonColumnDefs()"
          mat-header-row
          class="skeleton-header-row"
        ></tr>
        <tr
          *matRowDef="let row; columns: getSkeletonColumnDefs()"
          mat-row
          class="skeleton-row"
        ></tr>
      </table>
    </div>
  }
</div>
